import createReactComponent from '../createReactComponent';
export default createReactComponent('circuit-bulb', 'IconCircuitBulb', [
  ['path', { d: 'M2 12h5', key: 'svg-0' }],
  ['path', { d: 'M17 12h5', key: 'svg-1' }],
  ['path', { d: 'M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0', key: 'svg-2' }],
  ['path', { d: 'M8.5 8.5l7 7', key: 'svg-3' }],
  ['path', { d: 'M15.5 8.5l-7 7', key: 'svg-4' }],
]);
